const PHONE_MAX_SIZE_IN_PIXELS = 520 // Target 520x780
const TABLET_MAX_SIZE_IN_PIXELS = 768 // Target 1024x768

export const userDeviceInformation = () => {
  const info = window.navigator
  const usefulInfo = {}
  usefulInfo.userAgent = info?.userAgent
  usefulInfo.connectionType = info?.connection?.effectiveType
  usefulInfo.connectionRtt = info?.connection?.rtt
  usefulInfo.language = info?.language
  usefulInfo.languages = info?.languages && info?.languages.join(', ')
  usefulInfo.maxTouchPoints = info?.maxTouchPoints
  usefulInfo.platform =
    info?.userAgentData?.platform || navigator?.platform || 'unknown'
  usefulInfo.product = info?.product
  usefulInfo.userAgent = info?.userAgent
  usefulInfo.userAgentData = info?.userAgentData
  usefulInfo.vendor = info?.vendor

  return usefulInfo
}

export const isIosDevice = (customUserAgent) => {
  // El userAgent se fuerza porque a veces los iPad tienen el de un Mac.
  // Se añade la comprobación adicional de si es táctil
  // (Mejor algún falso positivo que muchos falsos negativos en este caso)
  const userAgent = (customUserAgent || navigator.userAgent).toLowerCase()
  const isIOSUserAgent = /ipad|iphone|mac\sos/i.test(userAgent)
  const isTouchDevice = navigator.maxTouchPoints > 1

  return isIOSUserAgent && isTouchDevice
}

export const isAndroidDevice = (customUserAgent) => {
  const userAgent = (customUserAgent || navigator.userAgent).toLowerCase()
  return /android/i.test(userAgent)
}

export const isDeviceSupported = () => {
  return true
}

export const getDeviceType = () => {
  const minimunSize = Math.min(window.innerWidth, window.innerHeight)

  if (minimunSize <= PHONE_MAX_SIZE_IN_PIXELS) {
    return 'phone'
  } else if (minimunSize <= TABLET_MAX_SIZE_IN_PIXELS) {
    return 'tablet'
  }

  return 'desktop'
}

export const isMobileOrTablet = () => {
  return getDeviceType() !== 'desktop'
}

export const isMobile = () => {
  return getDeviceType() === 'phone'
}

/*
// Por uso generalizado de smartphone con la versión web y tamaños muy pequeños de tablets
// se ha decidido al menos de manera provisional que todos los dispositivos sean soportados
// y que solo se tenga en cuenta el tamaño para definir el tipo de dispositivo

const MINIMUN_SIZE_IN_PIXELS = 550

export const isDeviceSupported = () => {
  const deviceType = getDeviceType()

  switch (deviceType) {
    case 'phone':
      return false

    default: {
      if (!isLargerThanMinimunSize()) return false
    }
  }

  return true
}

export const getDeviceType = (customUserAgent) => {
  const ua = (customUserAgent || navigator.userAgent).toLowerCase()
  let deviceType = 'desktop'

  // Check if it's ChromeOS or Chromebook.
  if (/cros/.test(ua) || /chromebook/.test(ua)) {
    return deviceType
  }

  // Las tablets iPad pueden usar como user agent el de un mac por eso añadimos este punto
  if (isIosDevice()) {
    if (ua.includes('iphone')) {
      deviceType = 'phone'
    } else {
      deviceType = 'tablet'
    }
  }
  // Si no es un dispositivo iOS se usa el método standar
  else if (
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      ua
    )
  ) {
    deviceType = 'tablet'
  } else if (
    /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(
      ua
    )
  ) {
    deviceType = 'phone'
  }

  return deviceType
}

export const isLargerThanMinimunSize = (
  minimunSize = MINIMUN_SIZE_IN_PIXELS
) => {
  const screenWidth = window.innerWidth // SIN devicePixelRatio es espacio para "dibujar", CON son pixeles reales
  const screenHeight = window.innerHeight // SIN devicePixelRatio es espacio para "dibujar", CON son pixeles reales

  if (screenWidth < minimunSize || screenHeight < minimunSize) return false

  return true
}
*/
